angular.module('logbook')
	.directive('reportScheduler', ['$http', '$q', 'batchRequest', '$timeout', '$uibModal', function($http, $q, batchRequest, $timeout, $uibModal)
	{
		return {
			restrict: 'E',
			template: require('app/reports/report-builder/report-schedule.html'),
			scope:{
				onBind: '=?',
				selectedLog: '=',
				settings: '=?',
				type: '='
			},
			link: {
				pre: function(scope, element, attribs)
				{
					function getDefaultCron()
					{
						return '* * * * *';
					}
					
					function ScheduledReport()
					{
						this.id = null;
						this.report = null;
						this.outputType = {id: 1};
						this.attachToEmail = false;
						
						this.lastRun = null;
						this.nextExecution = null;
						
						this.lastRunStatus = null;
						this.overrides = null;
						this.cronspec = getDefaultCron();
						this.shift = null;
						
						this.notifyUsers = [];
					}
					
					function verifyCron(timeout, cronStr, shift) {
						return $http.get('/api/cronSpecTest/scheduledReports', {
							noErrorPopup: true,
							timeout: timeout,
							params: {
								log: scope.selectedLog.id,
								cronSpec: cronStr,
								shift: shift ? shift.id : null
							}
						})
					}
					
					function executeVerification() {
						const scheduler = scope.scheduler.scheduler;
						if (!scheduler) return;
						
						const result = scheduler.getConverterResult();
						scope.scheduler.shift = Array.isArray(scheduler.shifts) ? scheduler.shifts[0] : null;
						scope.scheduler.cronspec = Object.values(result.cron).join(' ');
						
						if (scope.scheduler.timeoutDefer)
							scope.scheduler.timeoutDefer.resolve();
						
						let timeoutPromise = (scope.scheduler.timeoutDefer = $q.defer()).promise;
						scope.scheduler.verificationPromise = verifyCron(timeoutPromise, scope.scheduler.cronspec, scope.scheduler.shift)
							.then((result) => {
								scope.settings.hasCronError = !result.data;
								scheduler.errorMsg = result.data
									? ''
									: 'A report may not be scheduled more than once an hour.';
							})
					}
					
					var base = new ScheduledReport();
					
					scope.settings = scope.settings || base;
					scope.settings.ready = false;
					
					Object.keys(base).forEach(function(key)
					{
						if (!scope.settings.hasOwnProperty(key))
							scope.settings[key] = base[key];
					})
					
					scope.getSaveModel = function()
					{
						return {
							id: scope.settings.id,
							cronspec: scope.scheduler.cronspec,
							outputType: '/api/scheduledReportOutputType/' + scope.settings.outputType.id,
							attachToEmail: scope.settings.attachToEmail,
							notifyUsers: scope.userSelect.users.map(function(user){ return user._links.self.href }),
							shift: scope.scheduler.shift ? scope.scheduler.shift._links.self.href : null,
							report: scope.settings.report._links.self.href
						}
					}
					
					scope.settings.save = scope.save = function(asBatch)
					{
						var model = scope.getSaveModel();
						if (model.id > 0)
						{
							var href = scope.settings._links.self.href;
							if (scope.deleted)
								return (asBatch) ? batchRequest.req('DELETE', href) : $http.delete(href);
							else
								return (asBatch) ? batchRequest.req('PATCH', href, model) : $http.patch(href, model);
						}
						else if (!scope.deleted)
						{
							delete model.id;
							return (asBatch)
								? batchRequest.req('POST', '/api/scheduledReports', model)
								: $http.post('/api/scheduledReports', model);
						}
					}
					
					scope.settings.getVerificationPromise = () => $q.when(scope.scheduler.verificationPromise)
					
					scope.userSelect = {
						defer: $q.defer(),
						users: scope.settings.notifyUsers,
						onUsersRemoved: [],
						onBind: function(selectScope)
						{
							scope.userSelect.defer.resolve(selectScope);
							selectScope
								.setButtonInnerHtml('<span><i class="fa fa-plus"></i> Add Users</span>')
								.setFilter(function(user)
								{
									return !scope.userSelect.users.some(function(_user) { return _user.id === user.id; })
								})
								.addOnUserSelectedListener(function(user)
								{
									scope.userSelect.users.push(user);
								})
						},
						removeUser: function(user)
						{
							let removed = scope.userSelect.users.splice(scope.userSelect.users.indexOf(user), 1);
							if (Array.isArray(scope.userSelect.onUsersRemoved))
								scope.userSelect.onUsersRemoved.forEach(func => (typeof func === 'function') && func(removed))
						},
						promise: function()
						{
							return scope.userSelect.defer.promise;
						}
					}
					
					scope.showEmailDialog = () => {
						return $uibModal.open({
							backdrop: 'static',
							template: require('../../shared/modals/modal-confirm.html'),
							controller: ['$scope', function (modalScope) {
								modalScope.bodyStyleClass = 'whitespace-pre-line';
								modalScope.message = `Sending report output as attachments in e-mail causes the respective log content to be sent over the Internet's e-mail delivery network. There are a couple of things to be aware of when doing so:
								
								1. Internet e-mail is inherently insecure. It is not impossible that others could intercept or view the content of the e-mail.
								
								2. Mail servers along the store and forward route from the sender to the receiver may have content length limitations, which may prohibit delivery of large files.
								`;
								modalScope.acceptMessage = 'Accept';
								modalScope.rejectMessage = 'Cancel'
							}]
						})
							.result
					}
					
					Object.defineProperty(scope, 'attachToEmail', {
						get: () => scope.settings.attachToEmail,
						set: (v) => {
							if (!v) {
								scope.settings.attachToEmail = false;
								return;
							}
							scope.showEmailDialog()
								.then(
									() => true,
									() => false
								)
								.then(val => scope.settings.attachToEmail = val);
						}
					})
					
					scope.scheduler = {
						defer: $q.defer(),
						scheduler: null,
						cronSchedulerDefer: $q.defer(),
						cronspec: scope.settings.cronspec,
						shift: scope.settings.shift,
						timeoutDefer: undefined,
						verificationPromise: undefined,
						onChangeEvents: [],
						onBind: function(schedulerScope)
						{
							schedulerScope.addScheduler((scope.settings.type === 'shift' || scope.scheduler.shift) ? 'shift' : 'scheduler')
								.then(function(scheduler)
								{
									scheduler = scope.scheduler.scheduler = scheduler.scope;
									var split = scope.scheduler.cronspec.split(' ');
									var cron = {
										minutes: split[0],
										hours: split[1],
										monthdays: split[2],
										weekdays: split[4]
									};
									return scheduler.fromCronInput(cron)
										.then(function()
										{
											scope.settings.ready = true;
											scheduler.addOnChangeEvent(() =>
											{
												executeVerification();
												scope.scheduler.onChangeEvents.forEach(func => {
													if (typeof func === 'function')
														func(scope.scheduler);
												})
											})
											scheduler.addOnDeleteEvent(function(scheduler)
											{
												scope.settings.deleted = scope.deleted = true;
												scope.scheduler.scheduler = null;
												scope.scheduler.shift = null;
												scope.scheduler.cronspec = getDefaultCron();
												$timeout();
											})
											
											executeVerification();
											scope.scheduler.defer.resolve(schedulerScope);
											scope.scheduler.cronSchedulerDefer.resolve(scheduler);
										})
								})
						},
						promise: function()
						{
							return scope.scheduler.defer.promise;
						}
					}
					if (typeof scope.onBind === 'function')
						scope.onBind(scope);
				}
			}
		}
	}])